// extracted by mini-css-extract-plugin
module.exports = {"documentsPage":"documentsPage__ED0MN","overlay":"overlay__VY+Hh","dragOver":"dragOver__57N8K","editDocumentPlaceholder":"editDocumentPlaceholder__y9yeN"};